import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { UsageCostResponseBody } from '../types'

dayjs.extend(utc)

export const unitMappings: Record<string, string> = {
    USD: '$',
    KWH: 'kWh',
    MLBS: 'Mlbs',
    MMBTU: 'MMBtu',
    GAL: 'gal',
    LB: 'lb',
}

export const getUnitSymbol = (unit: string): string => {
    return unitMappings[unit] || unit // Fallback to the original unit if no mapping exists
}

export const processUsageCostResponse = (
    data: UsageCostResponseBody
): UsageCostResponseBody => {
    return {
        ...data,
        totals: mapUnits(data.totals, ['usage', 'cost', 'demand']),
        items: data.items.map((item) =>
            mapUnits(item, ['usage', 'cost', 'demand'])
        ),
    }
}

/**
 * Maps the units of specified fields in the given object.
 * @param obj - The object containing fields to map units for.
 * @param fields - An array of field names whose units need to be mapped.
 * @returns A new object with the specified fields' units mapped.
 */
const mapUnits = <
    T extends {
        usage?: { unit: string }
        cost?: { unit: string }
        demand?: { unit: string }
        [key: string]: unknown
    },
>(
    obj: T,
    fields: ('usage' | 'cost' | 'demand')[]
): T => {
    const result = { ...obj }

    for (const field of fields) {
        if (
            obj[field] &&
            typeof obj[field] === 'object' &&
            'unit' in (obj[field] as object)
        ) {
            result[field] = {
                ...obj[field],
                unit: getUnitSymbol((obj[field] as { unit: string }).unit),
            }
        }
    }

    return result
}
